<template>
    <div>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">User Edit</h4>
                    <p class="text-subtitle-1">Update User</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <UserForm 
                        ref="form"
                        v-model="data"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn 
                        color="primary"
                        block
                        @click="handleSubmit"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn
                        depressed
                        block
                        @click="handleCancel"
                        :loading="updateLoading"
                    >
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
            <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        </div>
         <div v-else>
             <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-3"/>
                    <v-skeleton-loader type="text" class="my-3"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>

                    <v-skeleton-loader type="text" />
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="me-5"/>
                    <v-skeleton-loader type="button"/>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import user from "./../../services/administration/user"
import PAlert from "./../../components/common/PAlert.vue"
import UserForm from './../../components/administration/UserForm'
export default {
    components: {
        UserForm,
        PAlert
    },
    data() {
        return {
            id: null,
            data: {},
            loading: false,
            updateLoading: false,
            alert:{
                title: "Alert",
                value: false,
                content: "",
                callback: null
            },
        }
    },
    methods: {
        ...mapActions({
           snackbar: "ui/snackbar/show"
        }),
        handleSubmit() {
            this.alert = {
                ...this.alert ,
                value: true,
                content: "Are you sure you want to save?",
                callback: this.submit
            }
        },
        fetchUser(id) {
            this.loading = true
            user.get(id).then(response => {
                this.data = response.data
            } ).finally(() => {
                this.loading = false
            })
        },
        submit() {
            
            this.updateLoading = true
            user.update({...this.data, id: this.id}).then(response => {
            if(response.data?.record?.id){
                this.snackbar({
                    text: response.data.message,
                    color: "success"
                })  
                this.$router.replace({ name:"UserDisplay", params:{ id :response?.data?.record?.id } })
            }else {
                let text = Object.values(response.data).join()
                this.snackbar({
                    text,
                    color: "error"
                })
            }
            }).finally(() => this.updateLoading = false )
                
        },
        handleCancel() {
            this.alert = {
                ...this.alert,
                value: true,
                content: "Are you sure you want to cancel?",
                callback: this.cancel   
            }
        },
        cancel() {
            this.$router.back()
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetchUser(this.id)
    }
}
</script>

<style>

</style>